<template>
<div :class="`page-content ${$i18n.locale} ${getCurrency($i18n.locale)}`">
  <Header />
  <router-view />

  <div class="cta-block cta-block-2 clearfix cta-block__spill">
    <div class="container">
      <div class="cta-block--container-width-sizer">
        <div class="cta-block--container">
          <div class="cta-block--container-row">
            <div class="cta-block--container-cell cta-block--text-cell " v-html="$t('general.cta-title')">
             <!-- <span class="word">{{$t('general.cta-title')}}</span> -->
            </div>
            <div class="cta-block--container-cell cta-block--cta-cell">

              <a href="/register"
                class="btn-fluid btn-lg-pad btn-negative btn btn-extruded"> {{$t('general.cta-button')}} </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer/>
</div>
</template>

<script>

import Header from './layout/Header'
import Footer from './layout/Footer'

var $ = require('jquery')
var imagesLoaded = require('imagesloaded')
import toggler from './jquery/toggler'
import utils from './jquery/utils'

export const currencyMap = {'en': 'usd', 'ja': 'jpy'}

export default {
  name: 'Bi-Winning',
  components: {
    Header, Footer,
  },
  mounted: function () {
  },
  methods: {
    getCurrency(locale) {
      return currencyMap[locale]
    }
  }
}
</script>
